module.exports = __webpack_public_path__ + "img/exp2.85514023.png";